/**
 * @file 扩展插件
 * @author WangZhuang
 */
/* eslint-disable */
import React from 'react';
import axios from 'axios';
import {Component} from 'react';
import secm from '@baidu/sec-monitor';
import moment from 'moment';
import {useLocation} from 'react-router-dom';

export function clearLocalStorage() {
    const channelId = window.localStorage.getItem('channelId');
    window.localStorage.clear();
    window.localStorage.setItem('channelId', channelId);
}
export const login = () => {
    const isDev = window.location.href.indexOf('haoma.baidu.com') > -1 ? false : true;
    const ele = document.createElement('a');
    ele.href = `https://passport${isDev ? '.qatest' : ''}.baidu.com/v2/?login&u=${
        encodeURIComponent(window.location.href)
    }`;
    ele.click();
};
export function handleLogin(fetchUserInfo) {
    const username = window.localStorage.getItem('username');
    if (!username) {
        fetchUserInfo().then(res => {
            const {code} = res || {};
            if (code === 200) {
                const username = window.localStorage.getItem('username');
                if (!username) {
                    window.localStorage.setItem('username', res.data.name);
                }
            } else {
                // window.localStorage.clear();
                clearLocalStorage();
                login();
            }
        });
    }
}

export function rcAjax(type, url, param, data, callback) {
    return axios({
        method: type,
        url: url,
        params: param,
        data: data
    })
        .then(response => {
            callback(response);
            return response.data;
        })
        .catch(error => {
            callback(error.response);
        });
}

export function inquiryFetch({method, url, params, data}) {
    const token = localStorage.getItem('__hms');
    return axios({
        method,
        url,
        params,
        data,
        headers: {'bd-hm-token': token}
    })
        .then(response => {
            const {code, data, message} = response.data;
            if (code === '2005') {
                localStorage.removeItem('__hms');
                window.location.replace('/inquiry/login');
            } else if (code === '1000') {
                return data;
            } else if (code === '3006') {
                Modal.confirm({
                    title: '提示!',
                    okText: '确认',
                    singleButton: true,
                    children: <div>
                        您好，该企业等级较高，请待人工确认后,
                        在<a href="/inquiry/i5Lu35YiX6KGo">人工询价列表界面</a>中查看价格
                    </div>
                });
                return {};
            } else if (code === '5005') {
                Modal.confirm({
                    title: '提示!',
                    okText: '确认',
                    singleButton: true,
                    children: <div>锁定失败，请在<a href="/inquiry/c2FsZXM=">线索客户</a>界面中，
                        完成该企业的线索处理（点击已处理并备注），方可锁定。
                    </div>
                });
                return {};
            } else {
                Modal.confirm({
                    title: '提示!',
                    okText: '确认',
                    singleButton: true,
                    children: <div>{message}</div>
                });
                // Toast.display({
                //     type: 'warning',
                //     info: message,
                //     delay: 3500
                // });
                return {};
            }
        })
        .catch(error => {
            console.error(error.response);
        });
}

export function extendComponent() {
    return function () {
        Component.prototype.isEmptyobj = function (obj) {
            // 判断是否为空对象
            for (let key in obj) {
                return false;
            }
            return true;
        };

        Component.prototype.isTest = function () {
            // 判断是否测试线
            let isLocalReg = new RegExp('(localhost|localtest|nj02|test|cq|cp01|safe-mobsec06)');
            return isLocalReg.test(window.location.host);
        };

        Component.prototype.getTime = function (val) {
            // 判断是否测试线
            // 比如需要这样的格式 yyyy-MM-dd hh:mm:ss
            let date = new Date(val);
            let Y = date.getFullYear() + '-';
            let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

            return Y + M + D;
        };

        Component.prototype.disableDate = current => {
            if (!current) {
                // allow empty select
                return false;
            }
            const date = moment();
            date.hour(0);
            date.minute(0);
            date.second(0);
            return current.valueOf() < date.add(-1, 'days').valueOf(); // can not select days before today
        };
    };
}
export const bCat_2055_request = fn => {
    window.BCat_2055 && window.BCat_2055.miao();
    /* eslint-disable */
    window['__abbaidu_2055_cb'] = responseData => {
        window['__abbaidu_2055_cb'] = null;
        let localData = JSON.parse(responseData);
        fn(localData);
    };
};

/**
 * Get the value of specific key in URL
 * @function getUrlValue
 * @param {string} name of the key
 * @returns {string} value of the key
 */
export const getUrlValue = (key) => {
    const searchValue = window.location.search.match(new RegExp("[?&]" + key + "=([^&]*)(&?)","i"))
    return searchValue ? searchValue[1] : searchValue
}

/**
 * 防刷接口代理
 */
export const _request = (fn, data) => {
    window.BCat_2055 && window.BCat_2055.miao();
    window['__abbaidu_2055_cb'] = responseData => {
        window['__abbaidu_2055_cb'] = null;
        let localData = JSON.parse(responseData);
        let json = {
            data: localData.data,
            key_id: localData['key_id'],
            sign: localData.sign,
            ...data
        };
        fn(json);
    };
};

/**
 * 格式化时间戳
 * @param fmt (格式，例：yyyy/MM/dd)
 * @param time (时间戳)
 * @returns 格式后的时间格式
 */
export const formatTime = (fmt, time) => {
    if (!time) return '';
    // 格式化时间
    const date = new Date(time);
    const o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        'S': date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (const k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1)
                ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
        }
    }
    return fmt;
};

// 备用
//width、height调用时传入具体像素值，控制大小 ,不传则默认图像大小
export const getBase64Img = img => {
    function getBase64Image(img, width, height) {
        const canvas = document.createElement('canvas');
        canvas.width = width ? width : img.width;
        canvas.height = height ? height : img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        return canvas.toDataURL('image/png');
    }
    const image = new Image();
    image.src = img;
    image.crossOrigin = 'anonymous';
    return new Promise((res, rej) => {
        image.onload = () => res(getBase64Image(image));
    });
};

export const getQueryString = name => {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    const search = location.search?.split('?')[1] || '';
    const r = search.match(reg) || [];
    return r[2];
};

const isObject = value => {
    return Object.prototype.toString.call(value) === '[object Object]';
};
const handleChannelActionTag = actionTag => {
    // 渠道号
    const channelId = getQueryString('zd') || window.localStorage.getItem('channelId');

    if (channelId && actionTag.indexOf('{') !== -1 && isObject(JSON.parse(actionTag))) {
        return JSON.stringify({
            ...JSON.parse(actionTag),
            zd: channelId
        });
    }

    // 无渠道号 || action_tag格式非对象，直接返回
    return actionTag;
};
export const recordProxy = (at, ae, aa) => {
    const _hmt = window._hmt || _hmt;
    const newAa = handleChannelActionTag(aa);
    _hmt.push(['_trackEvent', at, ae, newAa]);
    secm.action(at, ae, newAa);
};

export const validate = value => {
    const tempValue = value.replaceAll('-', '').replace(/\s+/g, '');
    const re = /^\d{5,10}$/;
    const re9 = /^9\d{3,11}$/;
    const rePhone = /^1[3456789]\d{9}$/;
    const reTel = /^0\d{2,3}-\d{7,8}$/;
    const reTel1 = /^0\d{2,3}\d{7,8}$/;

    return !re9.test(tempValue)
        && !re.test(tempValue)
        && !rePhone.test(tempValue)
        && !reTel.test(tempValue)
        && !reTel1.test(tempValue);
};

export const validateTellPhone = value => {
    const rePhone = /^1[3456789]\d{9}$/;
    return !rePhone.test(value);
}

/* eslint-disable */
export function checkNumber(value) {
    value = value.replace(/\s+/g, '');
    const reg = /(^(400|800)\-?\d{3}\-?\d{4}$)|(^(400|800)\-?\d{4}\-?\d{3}$)|(^(400|800)\d{1}\-?\d{3}\-?\d{3}$)|(^(1[3456789]\d{9})$)|(^0[\d]{2,3}\-?[\d]{3,}$)|(^1010\-?\d{4}$)|(^1\d{4}$)|(^(0[\d]{2,3}\-?)?(95|96)\d{3,11}$)/;
    return reg.test(value);
}
/* eslint-enable */

export const validateNumber = (value) => {
    const reg = /^\d+$/;
    return reg.test(value);
};

export const validateLetter = (value) => {
    const reg = /^[a-zA-Z]+$/;
    return reg.test(value);
};

export const validateSymbol = (value) => {
    const reg = /^[^a-zA-Z0-9\u4e00-\u9fa5]+$/g;
    return reg.test(value);
};

// 配置活动开始时间和活动结束时间
export const getIsFlashSale = () => {
    const {pathname} = useLocation();
    if (pathname !== '/attest' && pathname !== '/call_auth') {
        return false;
    }

    // 活动开始时间
    const FLASH_SALE_START_TIME = '2026/03/02 10:00:00';
    // 活动结束时间
    const FLASH_SALE_END_TIME = '2026/03/31 23:59:59';
    const currentTime = new Date().getTime();
    const flashSaleTimeStart = new Date(FLASH_SALE_START_TIME).getTime();
    const flashSaleTimeEnd = new Date(FLASH_SALE_END_TIME).getTime();
    return currentTime > flashSaleTimeStart && currentTime < flashSaleTimeEnd;
};